module.exports = __webpack_public_path__ + "static/media/office_desk.b245414f.svg";